import { render, staticRenderFns } from "./answers-list-mobile.vue?vue&type=template&id=35013eb1"
import script from "./answers-list-mobile.vue?vue&type=script&lang=js"
export * from "./answers-list-mobile.vue?vue&type=script&lang=js"
import style0 from "./answers-list-mobile.vue?vue&type=style&index=0&id=35013eb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports